module.exports = __webpack_public_path__ + "static/media/triple-superior.4.edfd5d19.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/rooms/triple-superior/images/triple-superior.4.jpg
// module id = 700
// module chunks = 0